import { render, staticRenderFns } from "./CelebrateOrderModal.vue?vue&type=template&id=2bd512dd&"
import script from "./CelebrateOrderModal.vue?vue&type=script&lang=js&"
export * from "./CelebrateOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports